/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation RateUpdateMutation($rateId: ID!, $type: CUSTOMER_TYPE!, $currency: String!, $displayName: String!) {
  RateUpdate(rateId: $rateId, type: $type, currency: $currency, displayName: $displayName) {
    message
    status
  }
}
`
